import { Flex, Text, Box } from '@chakra-ui/react';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading: boolean;
}

const RemoveBoardMemberModal = ({
  onRemove,
  isOpen,
  onClose,
  isLoading
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width={{ base: 'calc(100vw - 16px)', md: '450px' } as any}
    closeButtonProps={{
      hidden: true
    }}
  >
    <Flex
      flexDirection={'column'}
      gap={4}
      padding={8}
      justifyContent={'center'}
    >
      <Box fontSize="40px">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </Box>
      <Text textStyle="headingGroup">Remove Board Member?</Text>
      <Text textStyle="textBody">
        This action is irreversible. Do you wish to continue?
      </Text>
      <Flex justifyContent="flex-end" gap={2} alignItems="center">
        <Button onClick={onClose} variant="secondary" isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="caution"
          onClick={onRemove}
          isDisabled={isLoading}
          isLoading={isLoading}
        >
          Remove
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default RemoveBoardMemberModal;
